// Stabile Produkt-PKs aus public.products (charliescrew). Dienen dazu, adventure_bookings
// im neuen relationalen Modell nach Produkt zu filtern (product_id) — ohne Embed.
// Transitional: entfällt beim Cutover, wenn service_type gedroppt wird.
export const GASSI_PRODUCT_ID = "c8a4ff95-d8ac-458d-9694-f88ac8baf6cc";
export const DAYCARE_PRODUCT_ID = "a209e2f4-fbb1-47b3-9982-08c703ae40ca";